var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bat-result-scenario"},[_vm._l((Object.entries(_vm.batScenarioInfos)),function(ref,index){
var title = ref[0];
var infos = ref[1];
return _c('result-card',{key:index,staticClass:"scenario-card",attrs:{"title":title,"infos":infos}})}),_c('div',{staticClass:"parameters-card scenario-card"},[_c('div',{staticClass:"title"},[_vm._v("Parameters Used for the Project")]),_c('parameter-tabs')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }